import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const signup = async (data) => {
    const response = await fetch(`${baseUrl}/admin/signup`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
        redirect: "follow",
    });

    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    // console.log('signup data=================================================>', resData);
    return resData;
};

export const login = async (data) => {
    const response = await fetch(`${baseUrl}/api/staff/login`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        redirect: "follow",
    });
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    // console.log('login data========================================================>', resData);
    return resData;
};

export const getAllOwners = async () => {

        const response = await fetch(`${baseUrl}/api/superadmin/getallowners`, {
            headers: jwtHeaders(),
        });
        const resData = await response?.json();
        // console.log('all owners data=================================================>', resData);
        return resData;

};

export const googleLogin = async (idToken) => {
    const response = await fetch(`${baseUrl}/api/staff/google-login`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ idToken }),
        redirect: 'follow',
    });
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    return resData;
};